import actionTypes from './actionTypes';

const requestGame = (args) => ({
    type: actionTypes.REQUEST_GAME,
    payload: args,
});

const gameResponse = (success, errors, response) => ({
    type: actionTypes.GAME_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

const requestGameShifts = (args) => ({
    type: actionTypes.REQUEST_GAME_SHIFTS,
    payload: args,
});

const gameShiftsResponse = (success, errors, response) => ({
    type: actionTypes.GAME_SHIFTS_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

const requestTeamData = (args) => ({
    type: actionTypes.REQUEST_TEAM_DATA,
    payload: args,
});

const teamDataResponse = (success, errors, response) => ({
    type: actionTypes.TEAM_DATA_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    requestGame,
    gameResponse,
    requestGameShifts,
    gameShiftsResponse,
    requestTeamData,
    teamDataResponse,
};
